<template>
  <div :class="$style.dots">
    <span
      :class="[$style.dot, value === i - 1 && $style.active]"
      v-for="i in count"
      :key="i"
      @click="onClick(i - 1)"
    ></span>
  </div>
</template>

<script>
export default {
  name: 'UiSliderDots',
  props: {
    value: {
      type: Number,
      default: 1
    },
    count: {
      type: Number,
      default: 0
    }
  },
  emits: ['click'],
  methods: {
    onClick(index) {
      this.$emit('click', index)
    }
  }
}
</script>

<style lang="scss" module>
.dots {
  display: flex;
  margin: 0 1.6em;
}
.dot {
  cursor: pointer;
  width: 1.4em;
  height: 1.4em;
  background: color-get(--root-rgb-text-3);
  border-radius: 3em;
  margin: 0 0.4em;
  transition:
    width 0.2s ease-in,
    background-color 0.2s ease-in;

  &.active {
    cursor: default;
    background-color: color-get(--root-rgb-accent-2);
    width: 2.4em;
  }
}
</style>
